/**
 * Builds the URL used by the stand-in "Return to Cloud" action.
 *
 * Appends the origin org as an `organizationId` query param so the cloud app restores the
 * org the user was in on stand-in rather than its activity-based default. This relies on an
 * existing supported mechanism: root-store reads `organizationId` from the query string and
 * calls setCurrentOrganizationId before sign-in, which suppresses setSignInOrganization's
 * default selection. No new cloud-side behavior is introduced.
 *
 * Falls back to the raw base URL if it cannot be parsed.
 */
export function buildCloudUrl(baseUrl: string, currentOrganizationId: string | null): string {
  try {
    const url = new URL(baseUrl);
    if (currentOrganizationId) {
      url.searchParams.set('organizationId', currentOrganizationId);
    }
    return url.toString();
  } catch {
    return baseUrl;
  }
}

export default buildCloudUrl;
